import React, { useEffect, useState } from 'react';
import classes from './allSitesSearchBar.module.css';
import filters from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/filters2.png';
import sort from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/sorting.png';
import { serviceActions } from '../../store/service-Slice';
import { useDispatch, useSelector } from 'react-redux';
import DataManager from '../../hooks/DataManager';

// ── helpers ────────────────────────────────────────────────────

const toggle = (arr, val) =>
  arr.includes(val) ? arr.filter(v => v !== val) : [...arr, val];

const Section = ({ label, badge, open, onToggle, children }) => (
  <div className={classes.section}>
    <div className={classes.sectionHeader} onClick={onToggle}>
      <div className={classes.sectionHeaderLeft}>
        <span className={classes.sectionLabel}>{label}</span>
        {badge > 0 && <span className={classes.badge}>{badge}</span>}
      </div>
      <span className={`${classes.chevron} ${open ? classes.chevronOpen : ''}`}>▼</span>
    </div>
    {open && <div className={classes.sectionBody}>{children}</div>}
  </div>
);

const Pills = ({ options, selected, onToggle }) => (
  <div className={classes.pills}>
    {options.map(opt => (
      <button
        key={opt}
        type="button"
        className={`${classes.pill} ${selected.includes(opt) ? classes.pillActive : ''}`}
        onClick={() => onToggle(opt)}
      >
        {opt}
      </button>
    ))}
  </div>
);

const CheckRow = ({ label, checked, onChange }) => (
  <label className={classes.checkRow}>
    <input type="checkbox" checked={checked} onChange={onChange} />
    {label}
  </label>
);

// ── Component ──────────────────────────────────────────────────

const AllSitesSearchBar = (props) => {
  const {
    placeholder, 
    onChange, 
    value, 
    handleFocus, 
    handleBlur, 
    showFilterButton,
    groups, 
    includeSubgroups, setIncludeSubgroups,
    online, setOnline, 
    offline, setOffline,
    deviceTag, setDeviceTag,
    cloudController, setCloudController, 
    davantis, setDavantis, 
    G2CC, setG2CC, 
    ESP, setESP, 
    RPi, setRPi,
    groupName, setGroupName,
    submit, setSubmit,
    noTag, setNoTag,
    isControllers,
    noUsers, setNoUsers,
    liveViewStatus, setLiveViewStatus,
    scheduleOnly, setScheduleOnly,
    hasAjax, setHasAjax, 
    hasHik, setHasHik, 
    hasAIBOX, setHasAIBOX, 
    hasDahua, setHasDahua,
    active, setActive,
    hasPadlock, setHasPadlock, 
    hasKeybox, setHasKeybox, 
    hasGateway, setHasGateway,
    hasSigfox, setHasSigfox, 
    hasIndSigfox, setHasIndSigfox, 
    hasEfento, setHasEfento, 
    hasTeltonika, setHasTeltonika,
    hasSchedule, setHasSchedule, 
    hasTempSchedules, setHasTempSchedules,
    activePinCount, setActivePinCount,
    sortAsc, setSortAsc, 
    sUserCount, setSUserCount, 
    sCreated, setSCreated,
    sFirmware, setSFirmware, 
    sName, setSName, 
    sCameraCount, setSCameraCount,
    isGroupSites,
    isActiveSites,
    isInactiveSites,
    ruleV2Owner, setRuleV2Owner, 
    ruleV2Parent, setRuleV2Parent, 
    ruleV2Affected, setRuleV2Affected,
    connectionIssues, setConnectionIssues,
    hasCamerasLinked, setHasCamerasLinked,
    isInitialLoading, setIsInitialLoading,
    billable, setBillable, 
    billingFrequency, setBillingFrequency, 
    billedTo, setBilledTo, 
    sDateOfSale, setSDateOfSale,
    sLastInvoice, setSLastInvoice,
    sDateMadeActive, setSDateMadeActive
  } = props;

  const dispatch = useDispatch();
  const service = useSelector(state => state.service);
  const companyName = useSelector(state => state.auth.companyName);
  const isEyeSpyFX = companyName === 'EyeSpyFX';

  const [showFilters, setShowFilters] = useState(false);
  const [showSorts, setShowSorts] = useState(false);
  const [openSections, setOpenSections] = useState({});

  // ── local filter state ──────────────────────────────────────
  const [localOnline, setLocalOnline] = useState(online);
  const [localOffline, setLocalOffline] = useState(offline);
  const [localDeviceTag, setLocalDeviceTag] = useState(deviceTag);
  const [localGroupName, setLocalGroupName] = useState(groupName);
  const [localIncludeSubgroups, setLocalIncludesSubgroups] = useState(includeSubgroups);
  const [localNoTag, setLocalNoTag] = useState(noTag);
  const [localActive, setLocalActive] = useState(active);
  const [localNoUsers, setLocalNoUsers] = useState(noUsers);
  const [localLiveViewStatus, setLocalLiveViewStatus] = useState(liveViewStatus);
  const [localScheduleOnly, setLocalScheduleOnly] = useState(scheduleOnly);
  const [localHasAjax, setLocalHasAjax] = useState(hasAjax);
  const [localHasHik, setLocalHasHik] = useState(hasHik);
  const [localHasAIBOX, setLocalHasAIBOX] = useState(hasAIBOX);
  const [localHasDahua, setLocalHasDahua] = useState(hasDahua);
  const [localHasPadlock, setLocalHasPadlock] = useState(hasPadlock);
  const [localHasKeybox, setLocalHasKeybox] = useState(hasKeybox);
  const [localHasGateway, setLocalHasGateway] = useState(hasGateway);
  const [localHasSigfox, setLocalHasSigfox] = useState(hasSigfox);
  const [localHasIndSigfox, setLocalHasIndSigfox] = useState(hasIndSigfox);
  const [localHasEfento, setLocalHasEfento] = useState(hasEfento);
  const [localHasTeltonika, setLocalHasTeltonika] = useState(hasTeltonika);
  const [localHasSchedule, setLocalHasSchedule] = useState(hasSchedule);
  const [localHasTempSchedule, setLocalHasTempSchedule] = useState(hasTempSchedules);
  const [localActivePinCount, setLocalActivePinCount] = useState(activePinCount);
  const [localSortAsc, setLocalSortAsc] = useState(sortAsc);
  const [localSUserCount, setLocalSUserCount] = useState(sUserCount);
  const [localSCreated, setLocalSCreated] = useState(sCreated);
  const [localSFirmware, setLocalSFirmware] = useState(sFirmware);
  const [localSName, setLocalSName] = useState(sName);
  const [localSCameraCount, setLocalSCameraCount] = useState(sCameraCount);
  const [localRuleV2Owner, setLocalRuleV2Owner] = useState(ruleV2Owner);
  const [localRuleV2Parent, setLocalRuleV2Parent] = useState(ruleV2Parent);
  const [localRuleV2Affected, setLocalRuleV2Affected] = useState(ruleV2Affected);
  const [localConnectionIssues, setLocalConnectionIssues] = useState(connectionIssues);
  const [localHasCamerasLinked, setLocalHasCamerasLinked] = useState(hasCamerasLinked);

  // Billing filters (EyeSpyFX only)
  const [localBillable, setLocalBillable] = useState(billable ?? -1);
  const [localBilledTo, setLocalBilledTo] = useState(billedTo ?? -1);
  const [localBillingFrequency, setLocalBillingFrequency] = useState(billingFrequency ?? -1);
  const [localSDateOfSale, setLocalSDateOfSale] = useState(sDateOfSale ?? 0);
  const [localSLastInvoice, setLocalSLastInvoice] = useState(sLastInvoice ?? 0);
  const [localSDateMadeActive, setLocalSDateMadeActive] = useState(sDateMadeActive ?? 0);

  // Multi-select pill arrays
  const [connectedCCTVFilters, setConnectedCCTVFilters] = useState([]);
  const [connectedBLEFilters, setConnectedBLEFilters] = useState([]);
  const [connectedSensorFilters, setConnectedSensorFilters] = useState([]);
  const [siteStatusFilters, setSiteStatusFilters] = useState([]);
  const [activeStatusFilters, setActiveStatusFilters] = useState([]);
  const [siteTypeFilters, setSiteTypeFilters] = useState([]);

  const [hasFilters, setHasFilters] = useState(service.hasFilters);

  // sync from props
  useEffect(() => {
    setLocalOnline(online); setLocalOffline(offline); setLocalDeviceTag(deviceTag);
    setLocalGroupName(groupName); setLocalIncludesSubgroups(includeSubgroups);
    setLocalNoTag(noTag); setLocalNoUsers(noUsers); setLocalLiveViewStatus(liveViewStatus);
    setLocalScheduleOnly(scheduleOnly); setLocalHasAjax(hasAjax); setLocalHasHik(hasHik);
    setLocalHasAIBOX(hasAIBOX); setLocalHasDahua(hasDahua); setLocalHasPadlock(hasPadlock);
    setLocalHasKeybox(hasKeybox); setLocalHasGateway(hasGateway); setLocalHasSigfox(hasSigfox);
    setLocalHasIndSigfox(hasIndSigfox); setLocalHasEfento(hasEfento); setLocalHasTeltonika(hasTeltonika);
    setLocalHasSchedule(hasSchedule); setLocalHasTempSchedule(hasTempSchedules);
    setLocalActivePinCount(activePinCount); setLocalActive(active); setLocalSortAsc(sortAsc);
    setLocalSUserCount(sUserCount); setLocalSCreated(sCreated); setLocalSFirmware(sFirmware);
    setLocalSName(sName); setLocalSCameraCount(sCameraCount); setLocalRuleV2Owner(ruleV2Owner);
    setLocalRuleV2Parent(ruleV2Parent); setLocalRuleV2Affected(ruleV2Affected);
    setLocalConnectionIssues(connectionIssues); setLocalHasCamerasLinked(hasCamerasLinked);
    setLocalBillable(billable ?? -1); setLocalBilledTo(billedTo ?? -1); setLocalBillingFrequency(billingFrequency ?? -1);
    setLocalSDateOfSale(sDateOfSale ?? 0); setLocalSLastInvoice(sLastInvoice ?? 0); setLocalSDateMadeActive(sDateMadeActive ?? 0);

    setConnectedCCTVFilters([
      ...(hasAjax ? ['AJAX'] : []), ...(hasDahua ? ['Dahua'] : []),
      ...(hasHik ? ['Hikvision'] : []), ...(hasAIBOX ? ['Ganz AIBOX'] : [])
    ]);
    setConnectedBLEFilters([
      ...(hasPadlock ? ['Smart padlock'] : []), ...(hasKeybox ? ['Keybox'] : []),
      ...(hasGateway ? ['Gateway'] : [])
    ]);
    setConnectedSensorFilters([
      ...(hasSigfox ? ['Sigfox lite contact'] : []), ...(hasIndSigfox ? ['Sigfox industrial'] : []),
      ...(hasEfento ? ['Standalone NB-IOT Sensor'] : []), ...(hasTeltonika ? ['BLE Sensor'] : [])
    ]);
    setSiteStatusFilters([...(online ? ['Online'] : []), ...(offline ? ['Offline'] : [])]);
    setActiveStatusFilters(active === 1 ? ['Active'] : active === 0 ? ['Inactive'] : []);
    setSiteTypeFilters([
      ...(cloudController ? ['Cloud CC'] : []), ...(davantis ? ['Davantis'] : []),
      ...(G2CC ? ['Virtual'] : []), ...(ESP ? ['iON'] : []), ...(RPi ? ['RPi'] : [])
    ]);
  }, [
    online, offline, deviceTag, groupName, includeSubgroups, noTag, noUsers, liveViewStatus,
    scheduleOnly, hasAjax, hasHik, hasAIBOX, hasDahua, hasPadlock, hasKeybox, hasGateway,
    hasSigfox, hasIndSigfox, hasEfento, hasTeltonika, hasSchedule, hasTempSchedules,
    activePinCount, active, sortAsc, sUserCount, sCreated, sFirmware, sName, sCameraCount,
    cloudController, davantis, G2CC, ESP, RPi, ruleV2Owner, ruleV2Parent, ruleV2Affected,
    connectionIssues, hasCamerasLinked, billable, billedTo, billingFrequency, sDateMadeActive, sLastInvoice, sDateOfSale
  ]);

  const filterDefaults = {
    active: -1, online: 0, offline: 0, deviceTag: null, cloudController: 0, davantis: 0,
    g2cc: 0, ESP: 0, RPi: 0, groupName: null, includeSubgroups: 0, noTag: 0, searchTerm: null,
    noUsers: 0, liveViewStatus: -1, scheduleOnly: -1, hasAjax: 0, hasHik: 0, hasAIBOX: 0,
    hasDahua: 0, hasPadlock: 0, hasKeybox: 0, hasGateway: 0, hasSigfox: 0, hasIndSigfox: 0,
    hasEfento: 0, hasTeltonika: 0, hasSchedules: 0, hasTempSchedules: 0, activePinCount: -1,
    sortAsc: 0, sUserCount: 0, sCreated: 1, sFirmware: 0, sName: 0, sCameraCount: 0,
    ruleV2Owner: 0, ruleV2Parent: 0, ruleV2Affected: 0, connectionIssues: 0, hasCamerasLinked: -1,
    billable: -1, billedTo: -1, billingFrequency: -1, sDateMadeActive: 0, sLastInvoice: 0, sDateOfSale: 0
  };

  const setters = {
    online: setOnline, offline: setOffline, deviceTag: setDeviceTag,
    cloudController: setCloudController, davantis: setDavantis, g2cc: setG2CC,
    ESP: setESP, RPi: setRPi, groupName: setGroupName, includeSubgroups: setIncludeSubgroups,
    noTag: setNoTag, noUsers: setNoUsers, liveViewStatus: setLiveViewStatus,
    scheduleOnly: setScheduleOnly, hasAjax: setHasAjax, hasHik: setHasHik,
    hasAIBOX: setHasAIBOX, hasDahua: setHasDahua, hasPadlock: setHasPadlock,
    hasKeybox: setHasKeybox, hasGateway: setHasGateway, hasSigfox: setHasSigfox,
    hasIndSigfox: setHasIndSigfox, hasEfento: setHasEfento, hasTeltonika: setHasTeltonika,
    hasSchedules: setHasSchedule, hasTempSchedules: setHasTempSchedules,
    activePinCount: setActivePinCount, sortAsc: setSortAsc, sUserCount: setSUserCount,
    sCreated: setSCreated, sFirmware: setSFirmware, sName: setSName, sCameraCount: setSCameraCount,
    active: setActive, ruleV2Owner: setRuleV2Owner, ruleV2Parent: setRuleV2Parent,
    ruleV2Affected: setRuleV2Affected, connectionIssues: setConnectionIssues,
    hasCamerasLinked: setHasCamerasLinked, 
    billable: setBillable, 
    billedTo: setBilledTo, 
    billingFrequency: setBillingFrequency,
    sDateMadeActive: setSDateMadeActive,
    sLastInvoice: setSLastInvoice,
    sDateOfSale: setSDateOfSale
  };

  const toggleSection = (key) =>
    setOpenSections(prev => ({ ...prev, [key]: !prev[key] }));

  const handleClear = () => onChange({ target: { value: '' } });

  const handleShowFilters = () => { setShowFilters(p => !p); setShowSorts(false); };
  const handleShowSorts = () => { setShowSorts(p => !p); setShowFilters(false); };

  const HandleResetFilters = () => {
    setLocalOnline(0); setLocalOffline(0); setLocalDeviceTag(null); setLocalGroupName(null);
    setLocalIncludesSubgroups(0); setLocalNoTag(0); setLocalNoUsers(0);
    setLocalLiveViewStatus(-1); setLocalScheduleOnly(-1); setLocalHasAjax(0); setLocalHasHik(0);
    setLocalHasAIBOX(0); setLocalHasDahua(0); setLocalActive(-1); setLocalHasPadlock(0);
    setLocalHasKeybox(0); setLocalHasGateway(0); setLocalHasSigfox(0); setLocalHasIndSigfox(0);
    setLocalHasEfento(0); setLocalHasTeltonika(0); setLocalHasSchedule(0); setLocalHasTempSchedule(0);
    setLocalActivePinCount(-1); setLocalRuleV2Owner(0); setLocalRuleV2Parent(0);
    setLocalRuleV2Affected(0); setLocalConnectionIssues(0); setLocalHasCamerasLinked(-1);
    setLocalBillable(-1); setLocalBilledTo(-1); setLocalBillingFrequency(-1);
    setLocalSDateOfSale(0); setLocalSLastInvoice(0); setLocalSDateMadeActive(0);
    setConnectedCCTVFilters([]); setConnectedBLEFilters([]); setConnectedSensorFilters([]);
    setSiteStatusFilters([]); setActiveStatusFilters([]); setSiteTypeFilters([]);
    setSUserCount(0); setSCreated(1); setSFirmware(0); setSName(0); setSCameraCount(0);
    setBillable(-1); setBilledTo(-1); setBillingFrequency(-1); setSDateMadeActive(0); setSLastInvoice(0); setSDateOfSale(0)
    Object.entries(setters).forEach(([key, setter]) => setter(filterDefaults[key]));
    dispatch(serviceActions.resetFilters(filterDefaults));
    dispatch(serviceActions.setHasFilters(false));
    setHasFilters(false);
    setShowFilters(false);
  };

  const HandleApplyFilters = () => {
    const payload = {
      online: siteStatusFilters.includes('Online') ? 1 : 0,
      offline: siteStatusFilters.includes('Offline') ? 1 : 0,
      deviceTag: localDeviceTag,
      cloudController: siteTypeFilters.includes('Cloud CC') ? 1 : 0,
      davantis: siteTypeFilters.includes('Davantis') ? 1 : 0,
      g2cc: siteTypeFilters.includes('Virtual') ? 1 : 0,
      ESP: siteTypeFilters.includes('iON') ? 1 : 0,
      RPi: siteTypeFilters.includes('RPi') ? 1 : 0,
      groupName: localGroupName,
      includeSubgroups: localIncludeSubgroups,
      noTag: localNoTag,
      noUsers: localNoUsers,
      liveViewStatus: localLiveViewStatus,
      scheduleOnly: localScheduleOnly,
      hasAjax: connectedCCTVFilters.includes('AJAX') ? 1 : 0,
      hasHik: connectedCCTVFilters.includes('Hikvision') ? 1 : 0,
      hasAIBOX: connectedCCTVFilters.includes('Ganz AIBOX') ? 1 : 0,
      hasDahua: connectedCCTVFilters.includes('Dahua') ? 1 : 0,
      hasPadlock: connectedBLEFilters.includes('Smart padlock') ? 1 : 0,
      hasKeybox: connectedBLEFilters.includes('Keybox') ? 1 : 0,
      hasGateway: connectedBLEFilters.includes('Gateway') ? 1 : 0,
      hasSigfox: connectedSensorFilters.includes('Sigfox lite contact') ? 1 : 0,
      hasIndSigfox: connectedSensorFilters.includes('Sigfox industrial') ? 1 : 0,
      hasEfento: connectedSensorFilters.includes('Standalone NB-IOT Sensor') ? 1 : 0,
      hasTeltonika: connectedSensorFilters.includes('BLE Sensor') ? 1 : 0,
      hasSchedules: localHasSchedule,
      hasTempSchedules: localHasTempSchedule,
      activePinCount: localActivePinCount,
      sortAsc: localSortAsc,
      sUserCount: localSUserCount,
      sCreated: localSCreated,
      sFirmware: localSFirmware,
      sName: localSName,
      sCameraCount: localSCameraCount,
      ruleV2Owner: localRuleV2Owner,
      ruleV2Parent: localRuleV2Parent,
      ruleV2Affected: localRuleV2Affected,
      connectionIssues: localConnectionIssues,
      hasCamerasLinked: localHasCamerasLinked,
      active: activeStatusFilters.includes('Active') ? 1 : activeStatusFilters.includes('Inactive') ? 0 : -1,
      billable: localBillable,
      billedTo: localBilledTo,
      billingFrequency: localBillingFrequency,
      sDateOfSale: localSDateOfSale,
      sLastInvoice: localSLastInvoice,
      sDateMadeActive: localSDateMadeActive,
    };
    Object.entries(payload).forEach(([key, val]) => setters[key]?.(val));
    dispatch(serviceActions.updateFilters(payload));
    dispatch(serviceActions.setHasFilters(true));
    setHasFilters(true);
    setShowFilters(false);
    setShowSorts(false);
  };

  // ── badge counts ────────────────────────────────────────────
  const statusBadge = siteStatusFilters.length + activeStatusFilters.length;
  const devicesBadge = connectedCCTVFilters.length + connectedBLEFilters.length + connectedSensorFilters.length + (localConnectionIssues ? 1 : 0);
  const liveViewBadge = (localLiveViewStatus !== -1 ? 1 : 0) + (localHasCamerasLinked !== -1 ? 1 : 0);
  const schedulesBadge = (localHasSchedule !== 0 ? 1 : 0) + (localHasTempSchedule !== 0 ? 1 : 0) + (localScheduleOnly !== -1 ? 1 : 0);
  const rulesBadge = (localRuleV2Owner ? 1 : 0) + (localRuleV2Parent ? 1 : 0) + (localRuleV2Affected ? 1 : 0);
  const detailsBadge = (localNoTag ? 1 : 0) + (localNoUsers ? 1 : 0) + (localActivePinCount !== -1 ? 1 : 0) + (localDeviceTag ? 1 : 0) + siteTypeFilters.length;
  const groupBadge = (localGroupName ? 1 : 0) + (localIncludeSubgroups ? 1 : 0);

  const billingBadge = (localBillable !== -1 ? 1 : 0) + (localBilledTo !== -1 ? 1 : 0) + (localBillingFrequency !== -1 ? 1 : 0);
  const sortBadge = (localSUserCount ? 1 : 0) + (localSCreated ? 1 : 0) + (localSFirmware ? 1 : 0) + (localSName ? 1 : 0) + (localSCameraCount ? 1 : 0) + (localSDateOfSale ? 1 : 0) + (localSLastInvoice ? 1 : 0) + (localSDateMadeActive ? 1 : 0);

  const handleKeyPress = (e) => { if (e.key === 'Enter') e.preventDefault(); };

  return (
    <>
      <div className={classes.searchContainer}>
        <input
          className={classes.searchBar}
          placeholder={placeholder}
          value={value}
          onKeyPress={handleKeyPress}
          onChange={onChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          spellCheck={false}
        />

        <div className={classes.buttonGroup}>
          {value && (
            <button className={classes.clearButton} onClick={handleClear} type="button">×</button>
          )}
          {showFilterButton && (
            <button className={classes.filterButton} onClick={handleShowFilters} type="button">
              <img style={{ height: 30, width: 30 }} src={filters} />
            </button>
          )}
          {showFilterButton && (
            <button className={classes.filterButton} onClick={handleShowSorts} type="button">
              <img style={{ height: 30, width: 30 }} src={sort} />
            </button>
          )}
        </div>

        {/* ── Filter panel ─────────────────────────────────── */}
        {showFilters && (
          <div className={classes.panel}>
            <div className={classes.panelHeader}>
              <span className={classes.panelTitle}>Filters</span>
              <div className={classes.panelActions}>
                <button className={classes.resetBtn} type="button" onClick={HandleResetFilters}>Reset</button>
                <button className={classes.applyBtn} type="button" onClick={HandleApplyFilters}>Apply</button>
              </div>
            </div>

            <div className={classes.panelBody}>

              {/* Status */}
              <Section label="Status" badge={statusBadge} open={openSections.status} onToggle={() => toggleSection('status')}>
                <div className={classes.subSection}>
                  <span className={classes.subLabel}>Connectivity</span>
                  <Pills
                    options={['Online', 'Offline']}
                    selected={siteStatusFilters}
                    onToggle={v => setSiteStatusFilters(toggle(siteStatusFilters, v))}
                  />
                </div>
                {!isActiveSites && !isInactiveSites && (
                  <div className={classes.subSection}>
                    <span className={classes.subLabel}>Active status</span>
                    <Pills
                      options={['Active', 'Inactive']}
                      selected={activeStatusFilters}
                      onToggle={v => setActiveStatusFilters(toggle(activeStatusFilters, v))}
                    />
                  </div>
                )}
              </Section>

              {/* Connected devices */}
              <Section label="Connected devices" badge={devicesBadge} open={openSections.devices} onToggle={() => toggleSection('devices')}>
                <div className={classes.subSection}>
                  <span className={classes.subLabel}>CCTV integrations</span>
                  <Pills
                    options={['AJAX', 'Dahua', 'Hikvision', 'Ganz AIBOX']}
                    selected={connectedCCTVFilters}
                    onToggle={v => setConnectedCCTVFilters(toggle(connectedCCTVFilters, v))}
                  />
                  <CheckRow
                    label="Only show sites with CCTV connection issues"
                    checked={localConnectionIssues === 1}
                    onChange={() => setLocalConnectionIssues(localConnectionIssues === 1 ? 0 : 1)}
                  />
                </div>
                <div className={classes.subSection}>
                  <span className={classes.subLabel}>BLE devices</span>
                  <Pills
                    options={['Smart padlock', 'Keybox', 'Gateway']}
                    selected={connectedBLEFilters}
                    onToggle={v => setConnectedBLEFilters(toggle(connectedBLEFilters, v))}
                  />
                </div>
                <div className={classes.subSection}>
                  <span className={classes.subLabel}>Sensors</span>
                  <Pills
                    options={['Standalone NB-IOT Sensor', 'BLE Sensor']}
                    selected={connectedSensorFilters}
                    onToggle={v => setConnectedSensorFilters(toggle(connectedSensorFilters, v))}
                  />
                </div>
              </Section>

              {/* Live view */}
              <Section label="Live view" badge={liveViewBadge} open={openSections.liveview} onToggle={() => toggleSection('liveview')}>
                <Pills
                  options={['Enabled', 'Disabled']}
                  selected={localLiveViewStatus === 1 ? ['Enabled'] : localLiveViewStatus === 0 ? ['Disabled'] : []}
                  onToggle={v => {
                    if (v === 'Enabled') setLocalLiveViewStatus(localLiveViewStatus === 1 ? -1 : 1);
                    else setLocalLiveViewStatus(localLiveViewStatus === 0 ? -1 : 0);
                  }}
                />
                {localLiveViewStatus !== -1 && (
                  <div className={classes.subIndent}>
                    <span className={classes.subLabel}>Camera links</span>
                    <Pills
                      options={['With cameras', 'Without cameras']}
                      selected={localHasCamerasLinked === 1 ? ['With cameras'] : localHasCamerasLinked === 0 ? ['Without cameras'] : []}
                      onToggle={v => {
                        if (v === 'With cameras') setLocalHasCamerasLinked(localHasCamerasLinked === 1 ? -1 : 1);
                        else setLocalHasCamerasLinked(localHasCamerasLinked === 0 ? -1 : 0);
                      }}
                    />
                  </div>
                )}
              </Section>

              {/* Schedules */}
              <Section label="Schedules" badge={schedulesBadge} open={openSections.schedules} onToggle={() => toggleSection('schedules')}>
                <div className={classes.subSection}>
                  <span className={classes.subLabel}>Permanent schedules</span>
                  <Pills
                    options={['Has', "Doesn't have"]}
                    selected={localHasSchedule === 1 ? ['Has'] : localHasSchedule === 2 ? ["Doesn't have"] : []}
                    onToggle={v => {
                      if (v === 'Has') setLocalHasSchedule(localHasSchedule === 1 ? 0 : 1);
                      else setLocalHasSchedule(localHasSchedule === 2 ? 0 : 2);
                    }}
                  />
                </div>
                <div className={classes.subSection}>
                  <span className={classes.subLabel}>Temporary schedules</span>
                  <Pills
                    options={['Has', "Doesn't have"]}
                    selected={localHasTempSchedule === 1 ? ['Has'] : localHasTempSchedule === 2 ? ["Doesn't have"] : []}
                    onToggle={v => {
                      if (v === 'Has') setLocalHasTempSchedule(localHasTempSchedule === 1 ? 0 : 1);
                      else setLocalHasTempSchedule(localHasTempSchedule === 2 ? 0 : 2);
                    }}
                  />
                </div>
                <div className={classes.subSection}>
                  <span className={classes.subLabel}>Schedule only mode</span>
                  <Pills
                    options={['Enabled', 'Disabled']}
                    selected={localScheduleOnly === 1 ? ['Enabled'] : localScheduleOnly === 0 ? ['Disabled'] : []}
                    onToggle={v => {
                      if (v === 'Enabled') setLocalScheduleOnly(localScheduleOnly === 1 ? -1 : 1);
                      else setLocalScheduleOnly(localScheduleOnly === 0 ? -1 : 0);
                    }}
                  />
                </div>
              </Section>

              {/* Rules */}
              <Section label="Rules" badge={rulesBadge} open={openSections.rules} onToggle={() => toggleSection('rules')}>
                <div className={classes.pills}>
                  {[
                    { label: 'Has a rule', val: localRuleV2Owner, set: () => setLocalRuleV2Owner(localRuleV2Owner ? 0 : 1) },
                    { label: 'Is a parent site', val: localRuleV2Parent, set: () => setLocalRuleV2Parent(localRuleV2Parent ? 0 : 1) },
                    { label: 'Is a child site', val: localRuleV2Affected, set: () => setLocalRuleV2Affected(localRuleV2Affected ? 0 : 1) },
                  ].map(({ label, val, set }) => (
                    <button
                      key={label}
                      type="button"
                      className={`${classes.pill} ${val ? classes.pillActive : ''}`}
                      onClick={set}
                    >
                      {label}
                    </button>
                  ))}
                </div>
              </Section>

              {/* Site details */}
              <Section label="Site details" badge={detailsBadge} open={openSections.details} onToggle={() => toggleSection('details')}>
                <div className={classes.fieldRow}>
                  <span className={classes.fieldLabel}>Active switches</span>
                  <select
                    className={classes.nativeSelect}
                    value={localActivePinCount}
                    onChange={e => setLocalActivePinCount(Number(e.target.value))}
                  >
                    <option value={-1}>Any number</option>
                    {[0,1,2,3,4,5,6,7,8].map(n => (
                      <option key={n} value={n}>{n} active switch{n !== 1 ? 'es' : ''}</option>
                    ))}
                  </select>
                </div>
                <div className={classes.subSection}>
                  <span className={classes.subLabel}>Site type</span>
                  <Pills
                    options={['Davantis', 'Virtual', 'iON']}
                    selected={siteTypeFilters}
                    onToggle={v => setSiteTypeFilters(toggle(siteTypeFilters, v))}
                  />
                </div>
                <div className={classes.fieldRow}>
                  <span className={classes.fieldLabel}>Portal name contains</span>
                  <input
                    className={classes.textInput}
                    placeholder="Enter keyword..."
                    value={localDeviceTag || ''}
                    onChange={e => setLocalDeviceTag(e.target.value)}
                  />
                </div>
                <div className={classes.pills}>
                  {[
                    { label: 'No portal name', val: localNoTag, set: () => setLocalNoTag(localNoTag ? 0 : 1) },
                    { label: 'No users', val: localNoUsers, set: () => setLocalNoUsers(localNoUsers ? 0 : 1) },
                  ].map(({ label, val, set }) => (
                    <button
                      key={label}
                      type="button"
                      className={`${classes.pill} ${val ? classes.pillActive : ''}`}
                      onClick={set}
                    >
                      {label}
                    </button>
                  ))}
                </div>
              </Section>

              {/* Group — only when not in group sites context */}
              {!isGroupSites && (
                <Section label="Group" badge={groupBadge} open={openSections.group} onToggle={() => toggleSection('group')}>
                  <div className={classes.fieldRow}>
                    <select
                      className={classes.nativeSelect}
                      value={localGroupName || ''}
                      onChange={e => setLocalGroupName(e.target.value || null)}
                    >
                      <option value="">All groups</option>
                      {groups.map(g => g.name).sort((a, b) => a.localeCompare(b)).map(name => (
                        <option key={name} value={name}>{name}</option>
                      ))}
                    </select>
                  </div>
                  <CheckRow
                    label="Include all subgroups"
                    checked={localIncludeSubgroups === 1}
                    onChange={() => setLocalIncludesSubgroups(localIncludeSubgroups === 1 ? 0 : 1)}
                  />
                </Section>
              )}

              {/* Billing — EyeSpyFX only */}
              {isEyeSpyFX && (
                <Section label="Billing" badge={billingBadge} open={openSections.billing} onToggle={() => toggleSection('billing')}>
                  <div className={classes.subSection}>
                    <span className={classes.subLabel}>Billable</span>
                    <Pills
                      options={['Billable', 'Not billable', 'Demo']}
                      selected={localBillable === 1 ? ['Billable'] : localBillable === 0 ? ['Not billable'] : localBillable === 2 ? ['Demo'] : []}
                      onToggle={v => {
                        if (v === 'Billable') setLocalBillable(localBillable === 1 ? -1 : 1);
                        else if (v === 'Not billable') setLocalBillable(localBillable === 0 ? -1 : 0);
                        else setLocalBillable(localBillable === 2 ? -1 : 2);
                      }}
                    />
                  </div>
                  <div className={classes.subSection}>
                    <span className={classes.subLabel}>Billing frequency</span>
                    <Pills
                      options={['Monthly', 'Annually', 'Not set']}
                      selected={localBillingFrequency === 0 ? ['Monthly'] : localBillingFrequency === 1 ? ['Annually'] : localBillingFrequency === 2 ? ['Not set'] : []}
                      onToggle={v => {
                        if (v === 'Monthly') setLocalBillingFrequency(localBillingFrequency === 0 ? -1 : 0);
                        else if (v === 'Annually') setLocalBillingFrequency(localBillingFrequency === 1 ? -1 : 1);
                        else setLocalBillingFrequency(localBillingFrequency === 2 ? -1 : 2);
                      }}
                    />
                  </div>
                  <div className={classes.fieldRow}>
                    <span className={classes.fieldLabel}>Billed to</span>
                    <select
                      className={classes.nativeSelect}
                      value={localBilledTo}
                      onChange={e => setLocalBilledTo(Number(e.target.value))}
                    >
                      <option value={-1}>Any</option>
                      <option value={0}>Not set</option>
                      {[...groups].sort((a, b) => a.name.localeCompare(b.name)).map(g => (
                        <option key={g.id} value={g.id}>{g.name}</option>
                      ))}
                    </select>
                  </div>
                </Section>
              )}

            </div>
          </div>
        )}

        {/* ── Sort panel ───────────────────────────────────── */}
        {showSorts && (
          <div className={classes.panel}>
            <div className={classes.panelHeader}>
              <span className={classes.panelTitle}>Sort</span>
              <div className={classes.panelActions}>
                <button className={classes.resetBtn} type="button" onClick={HandleResetFilters}>Reset</button>
                <button className={classes.applyBtn} type="button" onClick={HandleApplyFilters}>Apply</button>
              </div>
            </div>
            <div className={classes.panelBody} style={{ padding: '14px 18px' }}>
              <div className={classes.subSection}>
                <span className={classes.subLabel}>Sort by</span>
                <div className={classes.sortGrid}>
                  {[
                    { label: 'Date created', active: localSCreated, onToggle: () => { setLocalSCreated(p => p ? 0 : 1); setLocalSUserCount(0); setLocalSFirmware(0); setLocalSName(0); setLocalSCameraCount(0); setLocalSDateOfSale(0); setLocalSLastInvoice(0); setLocalSDateMadeActive(0); } },
                    { label: 'User count', active: localSUserCount, onToggle: () => { setLocalSUserCount(p => p ? 0 : 1); setLocalSCreated(0); setLocalSFirmware(0); setLocalSName(0); setLocalSCameraCount(0); setLocalSDateOfSale(0); setLocalSLastInvoice(0); setLocalSDateMadeActive(0); } },
                    { label: 'Firmware', active: localSFirmware, onToggle: () => { setLocalSFirmware(p => p ? 0 : 1); setLocalSUserCount(0); setLocalSCreated(0); setLocalSName(0); setLocalSCameraCount(0); setLocalSDateOfSale(0); setLocalSLastInvoice(0); setLocalSDateMadeActive(0); } },
                    { label: 'Site name', active: localSName, onToggle: () => { setLocalSName(p => p ? 0 : 1); setLocalSUserCount(0); setLocalSCreated(0); setLocalSFirmware(0); setLocalSCameraCount(0); setLocalSDateOfSale(0); setLocalSLastInvoice(0); setLocalSDateMadeActive(0); } },
                    { label: 'Camera count', active: localSCameraCount, onToggle: () => { setLocalSCameraCount(p => p ? 0 : 1); setLocalSUserCount(0); setLocalSCreated(0); setLocalSFirmware(0); setLocalSName(0); setLocalSDateOfSale(0); setLocalSLastInvoice(0); setLocalSDateMadeActive(0); } },
                    ...(isEyeSpyFX ? [
                      { label: 'Date of sale', active: localSDateOfSale, onToggle: () => { setLocalSDateOfSale(p => p ? 0 : 1); setLocalSCreated(0); setLocalSUserCount(0); setLocalSFirmware(0); setLocalSName(0); setLocalSCameraCount(0); setLocalSLastInvoice(0); setLocalSDateMadeActive(0); } },
                      { label: 'Last invoice', active: localSLastInvoice, onToggle: () => { setLocalSLastInvoice(p => p ? 0 : 1); setLocalSCreated(0); setLocalSUserCount(0); setLocalSFirmware(0); setLocalSName(0); setLocalSCameraCount(0); setLocalSDateOfSale(0); setLocalSDateMadeActive(0); } },
                      { label: 'Date made active', active: localSDateMadeActive, onToggle: () => { setLocalSDateMadeActive(p => p ? 0 : 1); setLocalSCreated(0); setLocalSUserCount(0); setLocalSFirmware(0); setLocalSName(0); setLocalSCameraCount(0); setLocalSDateOfSale(0); setLocalSLastInvoice(0); } },
                    ] : []),
                  ].map(({ label, active, onToggle }) => (
                    <button
                      key={label}
                      type="button"
                      className={`${classes.sortPill} ${active ? classes.sortPillActive : ''}`}
                      onClick={onToggle}
                    >
                      {label}
                    </button>
                  ))}
                </div>
              </div>
              <div className={classes.subSection} style={{ marginTop: 10 }}>
                <span className={classes.subLabel}>Direction</span>
                <div className={classes.directionRow}>
                  <button
                    type="button"
                    className={`${classes.dirPill} ${localSortAsc === 1 ? classes.dirPillActive : ''}`}
                    onClick={() => setLocalSortAsc(1)}
                  >↑ Ascending</button>
                  <button
                    type="button"
                    className={`${classes.dirPill} ${localSortAsc === 0 ? classes.dirPillActive : ''}`}
                    onClick={() => setLocalSortAsc(0)}
                  >↓ Descending</button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {hasFilters && (
        <button className={classes.clearFiltersBtn} type="button" onClick={HandleResetFilters}>
          ✕ Clear filters
        </button>
      )}
    </>
  );
};

export default AllSitesSearchBar;
